import React from 'react';
import _ from 'lodash';
import { DateTime } from 'luxon';
import { useStateValue } from './data/order-calculator-context';
import { makeStyles, Button } from '~/lib/bn-material-ui';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    links: {
      padding: '0.25rem 0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& > Button': {
        color: theme.palette.blue[60],
      },
      '& > :first-child': {
        marginRight: '1rem',
      },
    },
    legend: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    unit: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.75rem',
      margin: '0 0 0 1rem',
      [theme.breakpoints.down('sm')]: {
        margin: '.5rem 0',
      },
    },
    brick: {
      minWidth: '2em',
      minHeight: '1em',
      marginRight: '1ch',
    },
    past: {
      background: theme.palette.gray[70],
    },
    predicted: {
      background: theme.palette.primary.main,
    },
    refill: {
      backgroundColor: theme.palette.lavender[60],
      opacity: 0.5,
    },
  };
});

function getRelativeOrders({ orders, activeOrderId, date }) {
  const sortedOrders = _.flatten(Object.keys(orders || {}).map(key => orders[key]));
  if (activeOrderId) {
    // relative to active order
    const index = _.findIndex(sortedOrders, order => order.getLinkByRel('self').href === activeOrderId);
    const prev = index > 0 ? sortedOrders[index - 1] : undefined;
    const next = index + 1 < sortedOrders.length ? sortedOrders[index + 1] : undefined;
    return { prev, next };
  }
  // relative to current time
  const index = _.sortedIndexBy(sortedOrders, { properties: { deliveryDate: date } }, ({ properties }) => properties.deliveryDate);
  const prev = index > 0 ? sortedOrders[index - 1] : undefined;
  const next = index < sortedOrders.length ? sortedOrders[index] : undefined;
  return { prev, next };
}

export default function BinLevelLegend() {
  const styles = useStyles();
  const [{
    activeOrderId,
    activeOrder,
    orders,
  }, dispatch] = useStateValue();

  const date = activeOrder.deliveryDate || DateTime.now().toISO();
  const { next, prev } = getRelativeOrders({ orders, activeOrderId, date });
  const selectOrder = order => dispatch({ type: 'selectOrder', activeOrderId: order?.getLink('self').href });

  return (
    <div className={styles.container}>
      <div className={styles.links}>
        <Button size='small' variant='text' disabled={!prev} onClick={() => selectOrder(prev)}>
          &lt; Prev Order
        </Button>

        <Button size='small' variant='text' disabled={!next} onClick={() => selectOrder(next)}>
          Next Order &gt;
        </Button>
      </div>

      <div className={styles.legend}>
        <div className={styles.unit}>
          <div className={`${styles.brick} ${styles.past}`} />
          <span>Past</span>
        </div>

        <div className={styles.unit}>
          <div className={`${styles.brick} ${styles.predicted}`} />
          <span>Predicted</span>
        </div>

        <div className={styles.unit}>
          <div className={`${styles.brick} ${styles.refill}`} />
          <span>Future Refill</span>
        </div>
      </div>
    </div>
  );
}
